export type Color =
  | 'purple'
  | 'blue'
  | 'salmon'
  | 'magenta'
  | 'yellow'
  | 'orange'
  | 'green'
  | 'red'
  | 'black'
  | 'lightGray'
  | 'darkGray'
  |'cOrange'

export const Colors: Record<Color, string> = {
  purple: '#8b3dfb',
  blue: '#5600fb',
  salmon: '#f97075',
  magenta: '#ff1dfc',
  yellow: '#FFFF00',
  orange: '#ffb62b',
  green: '#00ff43',
  red: '#ff001e',
  black: '#221f20',
  lightGray: '#bfbfbf',
  darkGray: '#979797',
  cOrange:'#FEC411'
};
